<div class="form-group row">
  <label for="selectedmetagroup" class="col-sm-4 col-form-label" i18n="@@choosecustomer">Choose a customer</label>
  <div class="col-8">
    <select class="custom-select" id="selectedmetagroup" [(ngModel)]="selectedMetagroup" (change)="onMetagroupChange()">
      <option [ngValue]="null">Choose a customer</option>
      <option *ngFor="let metagroup of metagroups$ | async" [ngValue]="metagroup" >{{metagroup.label}}</option>
    </select>
  </div>
</div>
